import { ReactElement } from "react";
import Chart from "../../../components/charts/chart";
import { useChartDimensions } from "../../../components/charts/chartUtils";
import { useTheme } from "@mui/material";

interface IProductionProgressProps {
  actual: number;
  expected: number;
  target: number;
}

const ProductionProgress = ({ actual, expected, target }: IProductionProgressProps): ReactElement => {
  const theme = useTheme();
  const [ref, dimensions] = useChartDimensions<HTMLDivElement>({
    height: 120,
    marginBottom: 20,
    marginLeft: 10,
    marginRight: 20,
    marginTop: 10
  });

  const indicator = (x: number, y: number, title: string, value: number, align: "start" | "middle" | "end", color: string) => {
    return(
      <g>
        <text x={x} y={y} textAnchor={align} fill={theme.palette.text.primary} fontWeight="bold" fontSize="1em">
          {title}
        </text>
        <text x={x} y={y + 20} textAnchor={align} fill={color} fontWeight="bold" fontSize="1.5em">
          {value}
        </text>

      </g>
    );
  };

  const getWidth = (value: number): number => value * dimensions.boundedWidth / target;

  return (
    <div ref={ref}>
      <Chart dimensions={dimensions}>
        <defs>
          <filter id="drop-shadow" x="-100%" y="-100%" width="300%" height="300%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
            <feOffset dx="3" dy="3" result="offsetblur"/>
            <feFlood floodColor="#a0a0a0"/>
            <feComposite in2="offsetblur" operator="in"/>
            <feMerge>
              <feMergeNode/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/*Target*/}
        <rect
          fill="#b0bec5"
          x={0}
          y={0}
          width={dimensions.boundedWidth}
          height={40} />

        {/*Actual*/}
        <rect
          fill="#2e7d32"
          x={0}
          y={0}
          width={getWidth(actual)}
          height={20} />

        {/*Expected*/}
        <rect
          fill="#0277bd"
          x={0}
          y={20}
          width={getWidth(expected)}
          height={20} />

        {indicator(0, dimensions.boundedHeight, "Actual", actual, "start", "#2e7d32")}
        {indicator(dimensions.boundedWidth / 2, dimensions.boundedHeight, "Expected", expected, "middle", "#0277bd")}
        {indicator(dimensions.boundedWidth, dimensions.boundedHeight, "Target", target, "end", "#b0bec5")}

      </Chart>
    </div>
  );
};

export default ProductionProgress;
